import React from 'react';

import ItemNew from './ItemNew';

type Props = {
	name: String,
	items: any,
	user: any,
	editable: Boolean,
	handleLogin(): void,
	handleUpvote(id): void,
	handleRemoveUpvote(item): void,
	loadData(): void,
	syncUpvoteCount?(itemId: number, upvoteCount: number): void,
	cravedIds?: Set<number>,
  handleToggleCraving?: (id: number) => void,
  // craving update: pass through login prompt for logged-out heart clicks
  handleLoginPrompt?: () => void,

};

const handleMainFilter = (value: boolean) => {
}

const CategoryItems: React.FC<Props> = (props) => {

	const loadData = async () => {
		props.loadData()
	}

	const handleNotificationClick= async(id)=>{
	}

	return (
		<div>
			<h2
				className="text-center lulo-bold f-28 mt-3 mb-3"
				style={{ letterSpacing:1 }}
			>
				{props.name}
			</h2>
			{
				props.items.length === 0	?
				<p className="text-center">No yolos.</p>
				:
				props.items.map((item, i) =>
					<ItemNew
						handleLogin={props.handleLogin}
						item={item}
						editable={props.editable}
						isLogged={props.user.isLogged}
						user={props.user} key={i}
						page={"categoryItems"}
						showRestaurant={true}
						handleUpvote={props.handleUpvote}
						handleRemoveUpvote={props.handleRemoveUpvote}
						handleNotificationClick={handleNotificationClick}
						loadData={loadData}
						syncUpvoteCount={props.syncUpvoteCount}
						restaurentPage={false}
						handleMainFilter={handleMainFilter}
						craved={props.cravedIds?.has(item.id)}
                        handleToggleCraving={props.handleToggleCraving}

                        handleLoginPrompt={props.handleLoginPrompt}


				/>
				)
			}
		</div>
	);
}

export default CategoryItems;
